import React from 'react'
import {Icon} from '@chakra-ui/react'

const MinusIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" data-testid="minus-icon" {...props} aria-hidden="true">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 19.6C8 19.2686 8.26863 19 8.6 19H31.4C31.7314 19 32 19.2686 32 19.6C32 19.9314 31.7314 20.2 31.4 20.2H8.6C8.26863 20.2 8 19.9314 8 19.6Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default MinusIcon
